module.exports = __webpack_public_path__ + "static/media/closed-toe-crocs-or-chef-shoes.50d1d2ae.jpg";